import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from 'react-native';
import { checkIsPlatform, getTestId } from '@airtel/air-design-system';
export var IngressImage = _ref => {
  var imageUrl = _ref.imageUrl,
    testID = _ref.testID,
    width = _ref.width,
    height = _ref.height;
  var isSvg = imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.endsWith('.svg');
  if (!imageUrl) return null;
  if (isSvg && !checkIsPlatform('web')) {
    var SvgUri = require('react-native-svg').SvgUri;
    return _jsx(SvgUri, Object.assign({
      uri: imageUrl,
      width: width,
      height: height
    }, getTestId(testID, 'Image')));
  }
  return _jsx(Image, Object.assign({}, getTestId(testID, 'Image'), {
    source: {
      uri: imageUrl,
      width,
      height
    },
    resizeMode: "contain"
  }));
};